import { Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import CustomCard from "./CustomCard";
import BookingTable from "./BookingTable";
import { useDashBoardQuery } from "../../hooks/useDashboardApi";
import blueImage from "../../assets/images/blue-Card.svg";
import dark from "../../assets/images/dark-Card.svg";
import yellowImage from "../../assets/images/yellow-Card.svg";


function Booking() {
  const { data } = useDashBoardQuery();
  const dashboardData = data?.data?.payload?.data;
  return (
    <div className="md:flex">
      <div className="">
        <SideBar />
      </div>
      <div className="flex-1 p-8 ">
        <Typography placeholder={undefined} className="text-3xl font-semibold">
          Booking
        </Typography>
        <Typography placeholder={undefined} className="my-4">
          See an overview of all your bookings here
        </Typography>
        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-20">
          <CustomCard
            title={dashboardData?.allBookings ?? "..."}
            image={dark}
            subtitle="All Bookings"
            textColor="text-white"
          />
          <CustomCard
            title={dashboardData?.activeBookings ?? "..."}
            image={blueImage}
            subtitle="Active Bookings"
          />
          <CustomCard
            title={dashboardData?.pendingBookings ?? "..."}
            image={yellowImage}
            subtitle="Pending Bookings"
          />
        </div>

        <BookingTable />
      </div>
    </div>
  );
}

export default Booking;
